module.exports = __webpack_public_path__ + "img/logo-white.f05830f3.png";